import {connect} from 'react-redux';
import PrintStamp from './components/PrintStamp';
import lodash from 'lodash';

import {clearPrintState} from './../../Common/PrintStamp/actions';

const mapStateToProps = (state) => {
    return {
        dataPrint: lodash.get(state, 'common.dataPrint', {}),
        agencySetting: lodash.get(state, 'setting.agencySetting', {}),
        globalSetting: lodash.get(state, 'setting.setting', {}),
    };
};

const mapDispatchToProps = {
    clearPrintState,
    // fetchSetting
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PrintStamp)